import Helper from './Helper';

class ESGTable {
  constructor() {

    this.marginal = Array.prototype.slice.call(document.querySelectorAll('.ns-esg-table__marginal'));
    this.content = Array.prototype.slice.call(document.querySelectorAll('.ns-esg-table__content'));

    if(this.marginal){
      this.copyMarginal();
    }

    if(this.content){
      this.copyContent();
    }
  }

  copyMarginal(){
    this.content.forEach(table => {
      let clone = table.cloneNode(true);
      clone.classList.add('ns-esg-table__content--cloned');
      let container = Helper.getClosest(table,'.ns-esg-table__container')
      container.append(clone);
    });
  }

  copyContent(){
    this.content.forEach(table => {
      let clone = table.cloneNode(true);
      clone.classList.add('ns-esg-table__content--cloned');
      let container = Helper.getClosest(table,'.ns-esg-table__container')
      container.append(clone);
    });
  }
} export default ESGTable;
